export const parseCookies = (docCookie) => {
    const cookies = docCookie
        .split(';')
        .map((s) => s.trim())
        .filter(Boolean)
        .reduce((res, next) => {
        const [k, v] = next.split('=');
        res[k.trim()] = v && v.trim ? v.trim() : '';
        return res;
    }, {});
    return cookies;
};
//# sourceMappingURL=parseCookies.js.map